module.exports = __webpack_public_path__ + "img/popup-left.cdd71aa3.svg";